<div class="pagination-comp">
  <div class="pagesize-wrapper">
    <label>
      <select (change)="setPagerSize($event)">
        <option
          [selected]="currentPageSize == option"
          *ngFor="let option of options"
          value="{{ option }}"
        >
          {{ option }}
        </option>
      </select>
      {{ "GENERIC.PAGE_SIZE" | translate }}</label
    >
  </div>
  <div class="separator"></div>
  <div class="pagination-wrapper">
    <div class="pages-label">{{ "GENERIC.PAGES" | translate }}:</div>
    <div *ngIf="lessPage" (click)="decrementAll()" class="page-item">
      <i class="fas fa-angle-double-left"></i>
    </div>
    <div *ngIf="lessPage" (click)="decrement()" class="page-item">
      <i class="fas fa-angle-left"></i>
    </div>
    <div *ngIf="lessPage" (click)="decrement()" class="page-item">
      {{ lessPage }}
    </div>
    <select (change)="setCurrentPager($event)">
      <option
        [selected]="currentPage == page"
        *ngFor="let page of pageList"
        value="{{ page }}"
      >
        {{ page }}
      </option>
    </select>
    <div *ngIf="morePage && morePage < pages" (click)="increment()" class="page-item">
      {{ morePage }}
    </div>
    <div *ngIf="morePage && morePage < pages" (click)="increment()" class="page-item">
      <i class="fas fa-angle-right"></i>
    </div>
    <div *ngIf="morePage && morePage < pages" (click)="incrementAll()" class="page-item">
      <i class="fas fa-angle-double-right"></i>
    </div>
  </div>
</div>
